import Loadable from 'components/core/Loadable';
import { lazy } from 'react';
import type { RouteObject } from 'react-router-dom';

// Auth
const CheckWarrantyPage = Loadable(lazy(() => import('pages/CheckWarranty/index')));


const CheckWarranty: RouteObject = {
  path: 'kiem-tra-san-pham-bao-hanh/:warrantyId',
  element: <CheckWarrantyPage />,
};

export default CheckWarranty;
